import { useMemo } from "react";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { PageContainer } from "../../components/PageContainer";
import ProductDetail from "../../components/ProductDetail";
import { getProduct } from "../../graphql/queries";

const ProductView = () => {
  const { productId } = useParams();
  const { data: productData } = useQuery(gql(getProduct), {
    variables: {
      id: productId,
    },
    skip: !productId,
  });

  const product = useMemo(() => productData?.getProduct || {}, [productData]);

  return (
    <PageContainer>
      <ProductDetail product={product} />
    </PageContainer>
  );
};

export default ProductView;
